import type { Contact } from '~/api/clients/types';

import type { DialogHandles } from '../ContactsTable.hooks';

import { mobileCellStyle, mobileHeaderStyle } from './contactCell.css';
import { ContactEmailsCell } from './ContactEmailsCell';
import { ContactNameCell } from './ContactNameCell';
import { ContactOptionsCell } from './ContactOptionsCell';
import { ContactPhoneCell } from './ContactPhoneCell';

type Props = {
  contact: Contact;
  dialogHandles: DialogHandles;
};

export const ContactMobileCell = ({ contact, dialogHandles }: Props) => {
  return (
    <div className={mobileCellStyle}>
      <div className={mobileHeaderStyle}>
        <ContactNameCell name={contact.fullName} />

        <ContactOptionsCell contact={contact} dialogHandles={dialogHandles} />
      </div>

      <ContactEmailsCell contact={contact} />

      <ContactPhoneCell phoneNumber={contact.phoneNumber} />
    </div>
  );
};
